import React from "react"
import moment from 'moment';
import Container from "react-bootstrap/Container";

export default function PostContent({ post, link = false }) {
    return (
        <Container>
            <div className="row mt-5 mb-5 justify-content-center">
                <div className="col col-lg-8 post">
                    {link ?
                        <a href={"/news/"+post.slug}><h1 className="post-title display-4 text-center">{post.title}</h1></a>
                        :
                        <h1 className="post-title display-4 text-center">{post.title}</h1>
                    }
                    <div className="row align-items-center py-5 border-top border-bottom">
                        <div className="col-auto">
                            <div className="avatar avatar-lg">
                                <img src={post.author.node.avatar.url} alt={post.author.node.name} className="avatar-img rounded-circle" />
                            </div>
                        </div>
                        <div className="col ms-n5">
                            <h6 className="text-uppercase mb-0">
                                {post.author.node.name}
                            </h6>
                            <time className="fs-sm text-muted" dateTime="2019-05-20">
                                Published on {moment(post.date).format('MMMM Do, YYYY')}
                            </time>
                        </div>
                        <div className="col-auto">
                            <ul className="d-inline list-unstyled list-inline list-social">
                                <li className="list-inline-item list-social-item me-3">
                                    <a className="twitter-share-button" href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(post.title)}&via=firstpartyhq`}>
                                        Tweet
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="post-content py-10" dangerouslySetInnerHTML={{ __html: post.content }} />
                </div>
            </div>
        </Container>
    )
}